import React from 'react';
import { Link } from 'react-router-dom'; // add this at the top
import './DonationSection.css';
import qricon from '../images/qricon.png'
import QR_ILM from '../images/QR_ILM.jpg'



const DonationSectionAnother = () => {
  return (
    <section className="donation-sectionn">
      <h2 className="heading">ILM FOUNDATION EDUCATION & WELFARE WAKF</h2>
      <h4 className="heading2">Donate Us In Our Mission</h4>

      <p className="subheading">
        Support us with your Donation, Sadaqaat & Zakaat and get rewarded here and in the here-after.
      </p>

      <div className="donation-content">
        <div className="quote-box">
          <p className="quote-box-para"><strong>The Prophet (ﷺ) said:</strong></p>
          <p className="quote">
            “The believer’s shade on the Day of Resurrection will be his charity.”
          </p>
          <p className="reference">[Musnad Ahmed: 3577]</p>
        </div>

        <div className="donate-info">
          <p className="donate-online-text">To Donate Online Click Button</p>
          <a
            href="https://pmny.in/HJ2AWtxjLqtp"
            target=""
            rel="noopener noreferrer"
            className="donate-btnn"
          >
            <img src={qricon} alt="Donate Button" className="donate-icon" />
            Donate Now
          </a>
          <p className="upi-text">Pay Via UPI</p>
          <p className="upi-id"><strong>UPI :</strong> <span className="upi-id-red">ilmFoundationEduWelf@hdfcbank</span></p>
        </div>

        <div className="qr-box">
          <p className="qr-text">Pay Via QR Code</p>
          <img src={QR_ILM} alt="QR Code" className="qr-code" />
        </div>
      </div>

      <p className="foreign-fund-note"><strong>AS OF NOW WE DO NOT HAVE PROVISION TO ACCEPT FOREIGN FUNDS</strong></p>
      {/* <p className="compliance-text">
        IRC is 12A ie Registered as Tax Exempt Charity, 80G ie Donor will get Tax Exemption & ISO 9001:2015 Compliant and is Eligible to take CSR Activities.
      </p> */}

      <Link to="/DonationDetailsAnother" className="read-more-btn">
        Learn More
      </Link>
    </section>
  );
};

export default DonationSectionAnother;